import { API_URL } from './api';

const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;

export const resolveDisplayImageUrl = (value) => {
  if (!value) {
    return null;
  }

  if (ABSOLUTE_URL_PATTERN.test(value)) {
    return value;
  }

  if (value.startsWith('/uploads/')) {
    return `${API_URL}${value}`;
  }

  return value;
};
